<template>
  <b-tab title="Transportes" class="m-0 p-0">
    <div class="tab-screen-list">
      <!-- :::::::::::::::::::::::::::: TABELA DA FROTA DE TRANSPORTE :::::::::::::::::::::::::::: -->
      <b-table bordered hover small head-variant="light" :items="getFilterVeiculos(filtro)" :fields="fields.veiculo">
        <template #cell(acoes)="data">
          <div>
            <b-button class="pt-0 pb-0" variant="link" @click="editar(data.item)" v-b-tooltip.hover title="Editar">
              <b-icon icon="pencil-square" variant="primary"> </b-icon>
            </b-button>
            <b-button class="pt-0 pb-0" variant="link" @click="display(data.item)" v-b-tooltip.hover title="CRLV">
              <b-icon icon="file-earmark-medical" variant="warning"> </b-icon>
            </b-button>
            <b-button
              class="pt-0 pb-0"
              variant="link"
              @click="abastecimentos(data.item)"
              v-b-tooltip.hover
              title="Abastecimentos"
            >
              <b-icon icon="droplet-half" variant="info"> </b-icon>
            </b-button>
            <b-button class="pt-0 pb-0" variant="link" @click="manutencoes(data.item)" v-b-tooltip.hover title="Manutenções">
              <b-icon icon="wrench" variant="info"> </b-icon>
            </b-button>
            <b-button class="pt-0 pb-0" variant="link" @click="relatorio(data.item)" v-b-tooltip.hover title="Relatório">
              <b-icon icon="file-earmark-post-fill" variant="success"> </b-icon>
            </b-button>
            <b-button class="pt-0 pb-0" variant="link" @click="deletar(data.item)" v-b-tooltip.hover title="Deletar">
              <b-icon icon="trash-fill" variant="danger"> </b-icon>
            </b-button>
          </div>
        </template>
      </b-table>
    </div>
    <!-- :::::::::::::::::::::::::::: BARRA DE AÇÕES :::::::::::::::::::::::::::: -->
    <div class="menu-acoes pb-2">
      <div id="search-bar">
        <b-col cols="12" class="p-1 pr-0">
          <b-form inline>
            <b-button size="sm" class="pl-2 pr-3" variant="info" @click="adicionar()">
              <b-icon icon="plus-circle" variant="light" scale="1.1" class="mr-2" />Adicionar
            </b-button>
            <b-form-input
              id="atv-desc-filter"
              type="search"
              size="sm"
              class="m-1 p-1"
              placeholder="Descrição"
              v-model="filtro.descricao"
            />
            <b-form-input id="atv-cor-filter" type="search" size="sm" class="m-1 p-1" placeholder="Cor" v-model="filtro.cor" />
            <b-form-input
              id="atv-placa-filter"
              type="search"
              size="sm"
              class="m-1 p-1"
              placeholder="Placa"
              v-model="filtro.placa"
            />
            <b-icon icon="search" variant="light" scale="1.2" class="m-1" />
            <b-button size="sm" class="m-1 ml-3" variant="light">
              {{ quantidade + " veículos" }}
            </b-button>
          </b-form>
        </b-col>
      </div>
      <!-- :::::::::::::::::::::::::::: MODAL DE EDIÇÃO :::::::::::::::::::::::::::: -->
      <veiculo-modal ref="editorVeiculo" />
      <display-crlv-modal ref="displayCrlv" />
      <abastecimento-list-modal ref="abastecimentoListModal" />
      <manutencao-list-modal ref="manutencaoListModal" />
      <relatorio-veiculo-modal ref="relatorioDespesasModal" />
      <confirm-modal ref="confirmDelVeiculo" :descricao="'Deseja realmente remover o transporte ?'" @executar="executar()" />
    </div>
  </b-tab>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useVeiculoStore } from "@/stores/VeiculoStore";
import Veiculo from "@/models/Veiculo";
import TableFields from "@/tools/TableFields";
import VeiculoModal from "@/components/modals/transporte/VeiculoModal";
import AbastecimentoListModal from "@/components/modals/transporte/AbastecimentoListModal";
import ManutencaoListModal from "@/components/modals/transporte/ManutencaoListModal";
import RelatorioVeiculoPrintModal from "@/components/modals/transporte/RelatorioVeiculoPrintModal";
import ConfirmModal from "@/components/modals/diversos/ConfirmModal.vue";
import DisplayCrlvModal from "@/components/modals/transporte/DisplayCrlvModal";
import Notificacao from "@/models/Notificacao";
import Files from "@/http/files";

export default {
  name: "VeiculoTabList",

  data() {
    return {
      fields: new TableFields(),
      filtro: {
        descricao: "",
        cor: "",
        placa: "",
      },
      veiculo: new Veiculo(0, "Novo Transporte", "", "", "", "", ""),
      files: new Files(this.$http),
    };
  },

  components: {
    "veiculo-modal": VeiculoModal,
    "confirm-modal": ConfirmModal,
    "abastecimento-list-modal": AbastecimentoListModal,
    "manutencao-list-modal": ManutencaoListModal,
    "relatorio-veiculo-modal": RelatorioVeiculoPrintModal,
    "display-crlv-modal": DisplayCrlvModal,
  },

  computed: {
    quantidade() {
      return this.getFilterVeiculos(this.filtro).length;
    },
  },

  methods: {
    adicionar() {
      this.veiculo = new Veiculo(0, "Novo Transporte", "", "", "", "", "");
      this.$refs.editorVeiculo.call(this.veiculo);
    },

    editar(veiculo) {
      this.$refs.editorVeiculo.call(veiculo);
    },

    display(veiculo) {
      this.files.downloadCrlv(veiculo.id).then((response) => this.$refs.displayCrlv.call(response));
    },

    abastecimentos(veiculo) {
      this.$refs.abastecimentoListModal.call(veiculo);
    },

    manutencoes(veiculo) {
      this.$refs.manutencaoListModal.call(veiculo);
    },

    relatorio(veiculo) {
      this.$refs.relatorioDespesasModal.call(veiculo);
    },

    deletar(veiculo) {
      this.veiculo.update(veiculo);
      this.$refs.confirmDelVeiculo.call();
    },

    executar() {
      this.veiculoStore.LISTAR_VEICULOS(this.veiculo.id).then(() => {
        if (this.getAbastecimentos.length === 0 && this.getManutencoes.length === 0) {
          this.veiculoStore.REMOVER_VEICULO(this.veiculo.id);
        } else {
          this.store.NOTIFICAR(new Notificacao("Existem manutenção e abastecimentos no veículo!", "Não Executado!", "danger"));
        }
      });
    },
  },

  setup() {
    const store = useSgcqStore();
    const veiculoStore = useVeiculoStore();
    const { getFilterVeiculos } = storeToRefs(veiculoStore);
    const { getAbastecimentos } = storeToRefs(veiculoStore);
    const { getManutencoes } = storeToRefs(veiculoStore);

    return {
      store,
      veiculoStore,
      getFilterVeiculos,
      getAbastecimentos,
      getManutencoes,
    };
  },
};
</script>

<style lang="scss" scoped>
#atv-desc-filter {
  width: 18rem;
}
#atv-cor-filter {
  width: 14rem;
}
#atv-placa-filter {
  width: 14rem;
}
.menu-acoes {
  background-color: #112a4a;
}
</style>
